import { createCollectionStore } from "../../../shared/data/createCollectionStore.js";
import {
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getCustomerShippingAddresses,
  addCustomerShippingAddress,
  deleteCustomerShippingAddress,
  updateCustomerCustomPrices
} from "../services/customerService.js";

// One shared, cached list of parties for every screen (Parties page, bill screens, payments, banking)
export const customerStore = createCollectionStore(getCustomers, {
  errorMessage: "Unable to load customers from database."
});

export function useCustomers() {
  const { data: customers, loading, error } = customerStore.useStore();
  const fetchCustomers = customerStore.refresh;

  const addCustomer = async (customerData) => {
    const id = await createCustomer(customerData);
    await fetchCustomers();
    return id;
  };

  const editCustomer = async (id, customerData) => {
    await updateCustomer(id, customerData);
    await fetchCustomers();
  };

  const removeCustomer = async (id) => {
    await deleteCustomer(id);
    await fetchCustomers();
  };

  const fetchAddresses = async (customerId) => {
    return await getCustomerShippingAddresses(customerId);
  };

  const addAddress = async (customerId, addressData) => {
    return await addCustomerShippingAddress(customerId, addressData);
  };

  const removeAddress = async (customerId, addressId) => {
    return await deleteCustomerShippingAddress(customerId, addressId);
  };

  const saveCustomerPrices = async (customerId, priceMap) => {
    await updateCustomerCustomPrices(customerId, priceMap);
    await fetchCustomers();
  };

  return {
    customers,
    loading,
    error,
    refetch: fetchCustomers,
    addCustomer,
    editCustomer,
    removeCustomer,
    fetchAddresses,
    addAddress,
    removeAddress,
    saveCustomerPrices
  };
}

export default useCustomers;
